import { Callback } from 'components/Callback';

const ScreenCallback = () => {
  return <Callback />;
};

export default ScreenCallback;
